import { Box, Text ,Link,Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink} from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectedMenu, setHeaderText } from "../../../redux/actions/actions";
import { loadTutorExamScheduleStatisticsReports } from "../../../redux/api_calls/apiCalls";
import {  useParams } from "react-router-dom";
  import { ChevronRightIcon } from '@chakra-ui/icons'
import { useHistory } from "react-router-dom";
export default function TutorExamScheduleStatistics() {
    let { tutorId } = useParams();
    let { schedule } = useParams();
    const headerText = useSelector(state => state.headerState.headerText)
    const { TutorExamScheduleStatsData } = useSelector(state => state.TutorExamScheduleStatsData)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch()
    let history = useHistory();

    useEffect(() => {
        dispatch(setHeaderText('Exam Answers'))
        dispatch(selectedMenu(7))
        dispatch(loadTutorExamScheduleStatisticsReports(tutorId,schedule))
    }, [dispatch,schedule,tutorId])

     useEffect(() => {
        
    }, [TutorExamScheduleStatsData])

   return (
       <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
        <Box width={['95%', '95%', '95%', '80%']}  alignItems='right' textAlign='right' mb='2rem' mt='2rem'>
                <Breadcrumb spacing='8px' separator={<ChevronRightIcon color='gray.500' />}>
                      <BreadcrumbItem>
                        <BreadcrumbLink href="/reports">Reports</BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbItem>
                        <BreadcrumbLink href="#"  onClick={history.goBack}>Tutor Reports</BreadcrumbLink>
                      </BreadcrumbItem>

                      <BreadcrumbItem isCurrentPage='true'>
                        <BreadcrumbLink href='#' _activeLink={{ color: '#4199e1',fontWeight:'bold',textDecoration:'none' }}>Tutor Exam Schedule Reports</BreadcrumbLink>
                      </BreadcrumbItem>

                    </Breadcrumb>
            </Box>

            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                w='80%'
                mb='1rem'

            >
                        <Box
                            w='100%'
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1rem'
                            px='1rem'
                            py='1rem'

                        >
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%'>Student Name</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Answer</Text>                
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Corrected Answer</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Result</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Mark</Text>
                        </Box>

          
                  </Box>
                  {TutorExamScheduleStatsData=== undefined ?
                    <Box
                        w='100%'
                        d='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        py='1rem'
                        fontSize='15px'
                        color='#000000'
                        fontWeight='600'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                    >
                    </Box>:
                     <Box w='80%' bg='white' borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'>
                    {Object.keys(TutorExamScheduleStatsData).map((keyName, keyIndex) => 
                  <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                w='100%'
                mb='1rem'


            >
                        <Box
                            w='100%'
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            px='1rem'
                            py='1rem'
                            borderBottom='1px solid rgba(0, 0, 0, 0.1)'
                        >
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%'>{TutorExamScheduleStatsData[keyName].students === null ? '' : TutorExamScheduleStatsData[keyName].students.first_name}</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' ,color:'red'}} width='20%' textAlign='center'><Link href={TutorExamScheduleStatsData[keyName]['answers_paper_doc']} style={{ textDecoration: 'none' }} target='_blank'>Open</Link></Text>                
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' ,color:'green'}} width='20%' textAlign='center'><Link href={TutorExamScheduleStatsData[keyName]['corrected_answer_papers']} style={{ textDecoration: 'none' }} target='_blank'>Open</Link></Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>{TutorExamScheduleStatsData[keyName]['result']}</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>{TutorExamScheduleStatsData[keyName]['marks']}</Text>
                        </Box>
                        
          
                  </Box>
                )   }
                     </Box>}
          
        </Box>
    )
}
